{
  "modal_message": "Hai già la Gucci App?",
  "modal_yes": "SÌ",
  "modal_no": "NO"
}
